// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    /*margin: 0;*/
    padding: 0;
    box-sizing: border-box;
    /*cursor: url(../public/Models/mec290.cur), auto;*/


}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,sBAAsB;IACtB,kDAAkD;;;AAGtD","sourcesContent":["*{\n    /*margin: 0;*/\n    padding: 0;\n    box-sizing: border-box;\n    /*cursor: url(../public/Models/mec290.cur), auto;*/\n\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
